import {Type} from 'class-transformer';

import {MessageLink} from '../messages/messageLink';

export class GroupContentItemLink {
  type: GroupContentItemType = 'links'
  item: MessageLink = null;
}

export class GroupContentItemMedia {
  type: GroupContentItemType = 'media'
  item: MessageLink = null;
}

/**
 * Group content
 *
 * @category Group Entity
 * */
export class GroupContentItem {
  messageId: string = null;
  groupId: string = null;

  /**
   * Date of state on server
   * */
  @Type(() => Date)
  date: Date | string = new Date();

  /**
   * Date of state on client, use this one to take date of change
   * */
  @Type(() => Date)
  dateClient: Date | string = new Date();

  /**
   *
   * */
  @Type(() => GroupContentItemLink, {
    discriminator: {
      property: 'type',
      subTypes: [
        {value: GroupContentItemLink, name: 'link'},
        {value: GroupContentItemLink, name: 'links'},
        {value: GroupContentItemMedia, name: 'media'},
        {value: GroupContentItemMedia, name: 'documents'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  data: GroupContentItemLink;

}

export type GroupContentItemType = 'links' | 'media' | 'documents';
